<template>
  <div class="info-tabs">
    <ul>
      <li
        v-if="template.meetingInfo.tab_1_p.display.value"
        @click="scrollTo('intro')"
      >
        {{ template.meetingInfo.tab_1_p.text.value }}
      </li>
      <li
        v-if="template.meetingInfo.tab_2_p.display.value"
        @click="scrollTo('agenda')"
      >
        {{ template.meetingInfo.tab_2_p.text.value }}
      </li>
      <li
        v-if="template.meetingInfo.tab_3_p.display.value"
        @click="scrollTo('guest')"
      >
        {{ template.meetingInfo.tab_3_p.text.value }}
      </li>
      <li
        v-if="template.meetingInfo.tab_4_p.display.value"
        @click="scrollTo('custom')"
      >
        {{ template.meetingInfo.tab_4_p.text.value }}
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
import { mixinsTemplate } from "../../common/mixinsTemplate";
export default {
  name: "InfoTabs",
  mixins: [mixinsTemplate],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    scrollTo(position) {
      $(".meeting-info").animate(
        {
          scrollTop:
            $("#" + position).offset().top + $(".meeting-info").scrollTop()
        },
        600
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
